<div class="lang-name">
  <span class="language-trigger" [matMenuTriggerFor]="languageChange">{{ lang | uppercase }}</span>
  <mat-menu #languageChange="matMenu" xPosition="before" yPosition="below">
    <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.HY)">
      {{ Language.HY | uppercase }}
    </p>
    <hr class="lang-mat-menu-hr">
    <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.EN)">
      {{ Language.EN | uppercase }}
    </p>
    <hr class="lang-mat-menu-hr">
    <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.RU)">
      {{ Language.RU | uppercase }}
    </p>
  </mat-menu>
</div>
